/**
 * Build-time feature flag for the SVG Patterns library in the Wallpaper picker.
 *
 * Additive + inert by default: while OFF, the "SVG Patterns" category is NOT
 * added to the Wallpaper picker's tab list, so the picker behaves exactly as it
 * did before this library existed (Colors / Gradient / Patterns / Image only).
 * The generator module + panel remain importable but unmounted. Flip per
 * environment via REACT_APP_BG_PATTERNS_ENABLED (staging sets "true").
 *
 * Mirrors the repo's featureFlag.js convention (CloneLineage/LinkedWheels/…).
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const BG_PATTERNS_ENABLED = truthy(
  process.env.REACT_APP_BG_PATTERNS_ENABLED
);
